import { PriceRange } from '@magentoTypes'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { useFormatPrice } from '~/hooks/useFormatPrice'

type Props = {
  priceRange: PriceRange | undefined
  regPriceClass?: string
  salePriceClass?: string
  productSelectorFormat?: boolean
  hideSalePrice?: boolean
  showSaveAmount?: boolean
  showOnCheckout?: boolean
}

export const Price = ({
  priceRange,
  regPriceClass,
  salePriceClass,
  productSelectorFormat,
  hideSalePrice,
  showSaveAmount,
  showOnCheckout,
}: Props) => {
  const { t } = useTranslation()
  const { formatPrice, formatPriceWithoutFraction } = useFormatPrice()
  if (!priceRange) return null
  const hasSalePrice =
    priceRange?.minimum_price?.final_price?.value !==
    priceRange?.minimum_price?.regular_price?.value
  return (
    <>
      {showOnCheckout ? (
        <div className="w-full">
          <div className="flex justify-end">
            <div
              className={clsx(
                'w-fit font-extralight text-primary-black',
                { 'line-through': hasSalePrice },
                regPriceClass,
              )}
            >
              {formatPrice(priceRange?.minimum_price?.regular_price)}
            </div>
          </div>
          {hasSalePrice && (
            <div className="flex justify-end">
              <div
                className={clsx(
                  'mt-2 w-fit bg-sg-neon-yellow px-2 font-extralight text-primary-black',
                  salePriceClass,
                )}
              >
                {formatPrice(priceRange?.minimum_price?.final_price)}
              </div>
            </div>
          )}
        </div>
      ) : hasSalePrice && !hideSalePrice ? (
        <div className="w-full">
          <div className="w-full">
            {productSelectorFormat ? (
              <div className="flex justify-end">
                <div className="w-fit">
                  <div
                    className={clsx(
                      'text-right font-extralight text-grey-dark line-through',
                      regPriceClass,
                    )}
                  >
                    {formatPrice(priceRange?.minimum_price?.regular_price)}
                  </div>
                  <div
                    className={clsx(
                      'mt-1 bg-sg-neon-yellow px-2 text-primary-black',
                      salePriceClass,
                    )}
                  >
                    {formatPrice(priceRange?.minimum_price?.final_price)}
                  </div>
                </div>
              </div>
            ) : (
              <>
                <span
                  className={clsx(
                    'mr-2.5 bg-sg-neon-yellow px-2.5 text-right font-extralight text-primary-black lgx:mr-4',
                    salePriceClass,
                  )}
                >
                  {formatPrice(priceRange?.minimum_price?.final_price)}
                </span>
                <span
                  className={clsx(
                    'text-right font-extralight text-grey-dark line-through',
                    regPriceClass,
                  )}
                >
                  {formatPrice(priceRange?.minimum_price?.regular_price)}
                </span>
              </>
            )}
          </div>
          {showSaveAmount && (
            <div className="mt-1 w-full text-[15px] text-primary-black">
              {t('You save {{amount}} {{currency}}', {
                amount: formatPriceWithoutFraction({
                  value: Math.abs(
                    (priceRange?.minimum_price?.final_price?.value as number) -
                      (priceRange?.minimum_price?.regular_price?.value as number),
                  ) as number,
                  currency: priceRange?.minimum_price?.final_price?.currency,
                }),
                currency: '',
              })}
            </div>
          )}
        </div>
      ) : (
        <span className={clsx(regPriceClass)}>
          {formatPrice(priceRange?.minimum_price?.regular_price)}
        </span>
      )}
    </>
  )
}
